import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Input,
  Label,
  Form,
  FormFeedback,
  Button,
  Spinner,
} from "reactstrap";
import logo from "../../assets/images/logo/logo.png";
import Swal from "sweetalert2";
// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import {
  validateReferralCode,
  addIndividualByPromoCode,
} from "../../slices/general/thunk";
import Loading from "../../Components/Loading";
import ReCaptcha from "../../Components/ReCaptcha";

const DashboardReferralCode = () => {
  const dispatch = useDispatch();
  const { code } = useParams();
  // #region STATES
  const [loading, setLoading] = useState(false);
  const [loadingCode, setLoadingCode] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [invalidCode, setInvalidCode] = useState("");
  const [showForm, setShowForm] = useState(true);

  const [theme, setTheme] = useState({
    color: "",
    logo: "",
  });

  const [referralUser, setReferralUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    companyName: "",
  });

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Please Enter Your First Name"),
      lastName: Yup.string().required("Please Enter Your Last Name"),
      email: Yup.string().required("Please Enter Your Email"),
    }),
    onSubmit: async (values) => {
      try {
        setError(null);
        setLoading(true);
        const response = await dispatch(
          addIndividualByPromoCode({
            code,
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
          })
        );
        if (response && response.payload && !response.payload.error) {
          setLoading(false);
          setSuccess(true);
          setShowForm(false);
        } else {
          setError(response.payload.error);
          setLoading(false);
        }
      } catch (error) {
        // console.log("error", error);
        setError(error.message);
        setLoading(false);
      }
    },
  });

  const handleValidateReferralCode = async () => {
    try {
      setLoadingCode(true);
      const response = await dispatch(
        validateReferralCode({
          code,
        })
      );

      if (response && response.payload && !response.payload.error) {
        setLoadingCode(false);
        setReferralUser({
          firstName: response.payload.firstName || "",
          lastName: response.payload.lastName || "",
          email: response.payload.email || "",
          companyName: response.payload.companyName || "",
        });
        setTheme({
          color: response.payload.theme.color,
          logo: response.payload.theme.logo,
          // logo: "https://d1d543rp3lnq6s.cloudfront.net/financialAdvantageConsultants.png",
        });
      } else {
        // Swal.fire({
        //   title: "Error!",
        //   text: "Invalid Referral Code",
        //   icon: "error",
        //   confirmButtonText: "Ok",
        // });
        setInvalidCode("Please check the referral code and try again. ");
        setShowForm(false);
        setLoadingCode(false);
      }
    } catch (error) {
      setLoadingCode(false);
    }
  };

  const handleInputChange = (event) => {
    const { name, value, email } = event.target;

    if (error) {
      setError(null);
    }

    validation.handleChange(event);
  };
  useEffect(() => {
    handleValidateReferralCode();
  }, [code]);

  if (loadingCode) {
    return <Loading />;
  }

  const referralUserInfo = referralUser.companyName
    ? referralUser.companyName
    : `${referralUser.firstName || ""} ${referralUser.lastName || ""} `;

  return (
    <React.Fragment>
      <ParticlesAuth background={theme.color}>
        <div className="auth-page-content">
          <ReCaptcha />
          <Container className="">
            <Row className="d-flex justify-content-center align-items-center mt-4">
              <Col md={8} lg={6} xl={5}>
                <Card className="">
                  <CardBody className="px-4 pb-1 pt-0">
                    <div className="text-center mt-2">
                      <Row>
                        <Col lg={12}>
                          <div className="text-center text-white-50">
                            {theme.logo ? (
                              <img
                                src={theme.logo}
                                alt="Logo"
                                className="img-fluid mx-auto d-block my-0"
                                style={{
                                  height: "auto",
                                  width: "200px",
                                  maxwidth: "200px",
                                }}
                              />
                            ) : (
                              <h3 className="mb-4">
                                {invalidCode ? (
                                  <>Invalid Referral Link</>
                                ) : (
                                  referralUserInfo
                                )}
                              </h3>
                            )}
                          </div>
                        </Col>
                      </Row>
                      {!invalidCode ? (
                        <div
                          style={{
                            boxShadow: theme.color
                              ? `0 0 2px ${theme.color}`
                              : "",
                          }}
                          className="p-2 rounded"
                        >
                          <span className="fst-italic">
                            Please complete the fields below to receive an email
                            invite link for your new prescription app.
                          </span>
                        </div>
                      ) : null}
                    </div>

                    <div className="p-2 mt-2">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                        className="needs-validation "
                        action="#"
                      >
                        {showForm ? (
                          <div div className={success ? "fade-out" : "fade-in"}>
                            <div className="mb-2">
                              <Label htmlFor="useremail" className="form-label">
                                First Name{" "}
                                <span className="text-danger">*</span>
                              </Label>
                              <Input
                                id="firstName"
                                name="firstName"
                                className="form-control"
                                placeholder="Enter First Name"
                                type="text"
                                onChange={handleInputChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.firstName || ""}
                                invalid={
                                  validation.touched.firstName &&
                                    validation.errors.firstName
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.firstName &&
                                validation.errors.firstName ? (
                                <FormFeedback type="invalid">
                                  <div>{validation.errors.firstName}</div>
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-2">
                              <Label htmlFor="useremail" className="form-label">
                                Last Name <span className="text-danger">*</span>
                              </Label>
                              <Input
                                id="lastName"
                                name="lastName"
                                className="form-control"
                                placeholder="Enter Last Name"
                                type="text"
                                onChange={handleInputChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.lastName || ""}
                                invalid={
                                  validation.touched.lastName &&
                                    validation.errors.lastName
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.lastName &&
                                validation.errors.lastName ? (
                                <FormFeedback type="invalid">
                                  <div>{validation.errors.lastName}</div>
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-2">
                              <Label htmlFor="useremail" className="form-label">
                                Email <span className="text-danger">*</span>
                              </Label>
                              <Input
                                id="email"
                                name="email"
                                className="form-control"
                                placeholder="Enter email address"
                                type="email"
                                onChange={handleInputChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.email || ""}
                                invalid={
                                  validation.touched.email &&
                                    validation.errors.email
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.email &&
                                validation.errors.email ? (
                                <FormFeedback type="invalid">
                                  <div>{validation.errors.email}</div>
                                </FormFeedback>
                              ) : null}
                            </div>{" "}
                          </div>
                        ) : (
                          <>
                            {success && success && (
                              <div className="fade-in mt-2 mb-2">
                                <>
                                  <ToastContainer autoClose={2000} limit={1} />
                                  <Alert color="success">
                                    Please check your email for further
                                    instructions. If you don't see the email in
                                    your inbox, please check your spam folder.
                                  </Alert>
                                </>
                              </div>
                            )}

                            {(error && error) ||
                              (invalidCode && (
                                <div className="fade-in">
                                  <Alert color="danger">
                                    <div>
                                      {error || invalidCode
                                        ? error || invalidCode
                                        : "Something went wrong. Please try again later or contact our support team."}
                                    </div>
                                  </Alert>
                                </div>
                              ))}
                          </>
                        )}

                        <div className="mt-4">
                          <Button
                            disabled={loading || success || error}
                            className={`btn btn_referral ${invalidCode ? "d-none" : ""
                              } btn-md w-100`}
                            type="submit"
                            style={{
                              backgroundColor: theme.color
                                ? theme.color
                                : "var(--vz-primary)",
                              borderColor: theme.color
                                ? theme.color
                                : "var(--vz-primary)",
                              minHeight: "40px",
                            }}
                          >
                            <div
                              className={`spinner-wrapper ${loading ? "fade-in" : "fade-out"
                                }`}
                            >
                              <Spinner size="sm" className="me-2">
                                Loading...
                              </Spinner>
                            </div>
                            {success && (
                              <div className="success-wrapper fade-in">
                                <i className="ri-checkbox-circle-fill mb-0 fw-bold fs-4 me-2"></i>{" "}
                                Submited
                              </div>
                            )}
                            {error && (
                              <div className="error-wrapper fade-in">
                                <i className="ri-error-warning-line mb-0 fw-bold fs-4 me-2"></i>{" "}
                                {error}
                              </div>
                            )}
                            {!loading && !success && !error && "Submit"}
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default DashboardReferralCode;
